import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { graphql, useStaticQuery } from 'gatsby';

import './problem_solution.scss';

import Html from '../../components/paragraph/html';


export default ({
  field_problem_solution,
  field_problem_solution_text,
  ...rest
}) => {
  const data = useStaticQuery(graphql`
    query {
      problemSVG: file(
        relativePath: { eq: "problem-icon--purple.svg" }
      ) {
        publicURL
      }
      solutionSVG: file(
        relativePath: { eq: "result-icon--purple.svg" }
      ) {
        publicURL
      }
    }
  `);

  const iconProblem = (
    <Col xs={12} md={6} className="problem">
      <img
        src={data.problemSVG.publicURL}
        alt={'Case Study Problem Icon'}
        className="svg"
      />
      <h3>Problem</h3>
      <Html props={field_problem_solution_text[0].field_html} />
    </Col>
  );
  const iconSolution = (
    <Col xs={12} md={6} className="solution">
      <img
        src={data.solutionSVG.publicURL}
        alt={'Case Study Problem Icon'}
        className="svg"
      />
      <h3>Solution</h3>
      <Html props={field_problem_solution_text[1].field_html} />
    </Col>
  );

  return (
    <section {...rest}>
      <Container>
        <Row>
          {iconProblem}
          {iconSolution}
        </Row>
      </Container>
    </section>
  );
};
